import { render, staticRenderFns } from "./translationdeleteDialog.vue?vue&type=template&id=68c6bc6a&scoped=true&"
import script from "./translationdeleteDialog.vue?vue&type=script&lang=js&"
export * from "./translationdeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./translationdeleteDialog.vue?vue&type=style&index=0&id=68c6bc6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6bc6a",
  null
  
)

export default component.exports